// extracted by mini-css-extract-plugin
export default {"container":"ChangeQRCode_container__jkibY","title":"ChangeQRCode_title__HlCDU","body":"ChangeQRCode_body__1TOuY"};